var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnDataManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-2 {\n        stroke: #FFFFFF;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 64,
    height: 64
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn_data_management"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.72,28.37v-7.91c0-4.33-7.97-7.84-17.81-7.84s-17.81,3.51-17.81,7.84v17.81c0,4.18,7.43,7.59,16.79,7.83.34,0,.68.01,1.02.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.72,20.47c0,4.33-7.97,7.84-17.81,7.84s-17.81-3.51-17.81-7.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.91,37.57c-.34,0-.67,0-1-.01-9.38-.23-16.81-3.64-16.81-7.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "49.16 45.63 50.38 47.04 47.57 49.85 46.17 48.63 44.02 49.52 43.9 51.37 39.92 51.37 39.79 49.52 37.65 48.63 36.24 49.85 33.43 47.04 34.65 45.63 33.76 43.49 31.91 43.36 31.91 39.38 33.76 39.26 34.65 37.11 33.43 35.71 36.24 32.89 37.65 34.12 39.79 33.23 39.92 31.37 43.9 31.37 44.02 33.23 46.17 34.12 47.57 32.89 50.38 35.71 49.16 37.11 50.05 39.26 51.91 39.38 51.91 43.36 50.05 43.49 49.16 45.63"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 41.91,
    cy: 41.37,
    r: 4
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDataManagement);
export default __webpack_public_path__ + "static/media/icn_data_management.a69535b7771299bd16ea02c6f4a34174.svg";
export { ForwardRef as ReactComponent };